import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import InviteReferralPartnerEmailPreview from '@/components/modals/InviteReferralPartnerEmailPreview'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { faInfoCircle } from '@/lib/fontAwesomePro/regular'

const PreviewEmail: React.FC = () => {
  const [showEmailPreview, setShowEmailPreview] = React.useState<boolean>(false)

  return (
    <>
      <Button
        variant="plain"
        className="text-primary"
        onClick={() => setShowEmailPreview(true)}
      >
        Preview invite
      </Button>

      {showEmailPreview && (
        <Dialog open onHide={() => setShowEmailPreview(false)}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Preview of invitation email</DialogTitle>
            </DialogHeader>

            <DialogBody>
              <Alert variant="info" className="mb-4">
                <FontAwesomeIcon icon={faInfoCircle} fixedWidth size="lg" />
                <AlertDescription>
                  Once this invite request has been approved, this is the
                  invitation email this firm will receive.
                </AlertDescription>
              </Alert>

              <InviteReferralPartnerEmailPreview />
            </DialogBody>

            <DialogFooter>
              <Button
                variant="outline-secondary"
                onClick={() => setShowEmailPreview(false)}
              >
                Close
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default PreviewEmail
